import types from 'store/constants/@client/userInfo.constants';
import { RootState } from 'store/types';

export const userInfoSelector = (state: RootState) => state.userInfo;

export const recentPropertySelector = (state: RootState) =>
  userInfoSelector(state).recentProperty;
export const recentPropertyLoadingSelector = (state: RootState) =>
  userInfoSelector(state).loading[types.GET_RECENT_PROPERTY_REQUEST];
